export const expertPrimaryTabStyle = {
  display: "flex",
  alignItems: "center",
  gap: "0.3rem",
  width: "100%",
  maxWidth: "max-content",
};

export const primaryTabPStyle = {
  backgroundColor: "#16A848",
  color: "white",
  width: "18px !important",
  height: "18px !important",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: "600",
  borderRadius: "50%",
  fontSize: "8px",
  cursor: "pointer",
};
